(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-item')) {
    customElements.define(
      'accordion-item',
      class AccordionItem extends HTMLElement {
        constructor() {
          super();
          this.heading = this.querySelector('.accordion-container__heading-area');
          this.content = this.querySelector('.accordion-container__content');

          this.heading.addEventListener('click', () => this.toggleAccordion());
        }

        close() {
          this.classList.remove('open');
          this.content.style.height = '0px';
        }

        open() {
          this.classList.add('open');
          this.content.style.height = `${this.content.scrollHeight}px`;
        }

        getScope() {
          return this.closest('[class*="accordion-wrapper"]') || document;
        }

        toggleAccordion() {
          this.getScope()
            .querySelectorAll('accordion-item')
            .forEach((item) => {
              if (item !== this) item.close();
            });

          if (this.classList.contains('open')) this.close();
          else this.open();
        }

        connectedCallback() {
          this.content.style.height = '0px';

          const scopedItems = this.getScope().querySelectorAll('accordion-item');
          if (scopedItems[0] === this) {
            requestAnimationFrame(() => this.open());
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
